/* Paddock collection page (sections/paddock-collection.liquid), 2026-09-26.
 *
 * Progressive enhancement over a plain GET form: every filter change, sort
 * change, chip removal and "Load more" fetches the same URL through Shopify's
 * Section Rendering API (?section_id=) and swaps the parts that changed. With
 * no script the form still submits and every chip is a real link.
 *
 * On phones the form is a full-height sheet. Changes apply live while it is
 * open, so the "Show N results" button only has to close it.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var form = root.querySelector('[data-pc-form]');
  var openBtn = root.querySelector('[data-pc-open]');
  var scrim = root.querySelector('[data-pc-scrim]');
  var controller = null;
  var lastFocus = null;

  function sectionUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('page');
    return u;
  }

  function formUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    // The sort select lives outside the form (form= attribute) — FormData includes it.
    return form.getAttribute('action') + (params.toString() ? '?' + params.toString() : '');
  }

  function fetchDoc(url, signal) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { signal: signal, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  // One request in flight at a time: a newer filter change or "Load more"
  // aborts the older one (and a Back restore, which shares the controller).
  function fetchSection(url) {
    if (controller) controller.abort();
    controller = new AbortController();
    return fetchDoc(url, controller.signal);
  }

  function swap(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = root.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
    return fresh;
  }

  // Keep which <details> groups are open across a swap, so a phone user does
  // not watch the group they are working in collapse under their thumb.
  function openGroups() {
    var labels = [];
    root.querySelectorAll('[data-pc-groups] details[open] > summary').forEach(function (s) {
      labels.push(s.textContent.trim());
    });
    return labels;
  }

  function restoreGroups(labels) {
    root.querySelectorAll('[data-pc-groups] details > summary').forEach(function (s) {
      var d = s.parentElement;
      if (labels.indexOf(s.textContent.trim()) !== -1) d.setAttribute('open', '');
      else if (!d.querySelector('input:checked')) d.removeAttribute('open');
    });
  }

  function render(url) {
    var focusedName = document.activeElement && document.activeElement.name;
    var focusedValue = document.activeElement && document.activeElement.value;
    var groups = openGroups();
    var groupsScroll = (root.querySelector('[data-pc-groups]') || {}).scrollTop || 0;

    root.classList.add('is-loading');
    return fetchSection(url).then(function (doc) {
      swap(doc, '[data-pc-results]');
      swap(doc, '[data-pc-groups]');
      swap(doc, '[data-pc-results-count]');
      swap(doc, '[data-pc-active-count]');
      swap(doc, '[data-pc-show]');
      swap(doc, '[data-pc-clear]');
      restoreGroups(groups);

      var groupsEl = root.querySelector('[data-pc-groups]');
      if (groupsEl) groupsEl.scrollTop = groupsScroll;

      // Put focus back on the control the shopper just used.
      if (focusedName) {
        var sel = '[name="' + CSS.escape(focusedName) + '"]';
        var candidates = root.querySelectorAll(sel);
        for (var i = 0; i < candidates.length; i++) {
          if (candidates[i].type !== 'checkbox' || candidates[i].value === focusedValue) {
            candidates[i].focus({ preventScroll: true });
            break;
          }
        }
      }

      var clean = new URL(url, window.location.origin);
      clean.searchParams.delete('section_id');
      history.replaceState({ pc: true }, '', clean.pathname + clean.search);
      // The filter column was replaced; anything that draws into it re-initialises.
      root.dispatchEvent(new CustomEvent('pc:rendered'));
    }).catch(function (err) {
      if (err.name === 'AbortError') return;
      // Anything unexpected: fall back to a normal navigation.
      window.location.href = url;
    }).finally(function () {
      root.classList.remove('is-loading');
    });
  }

  var priceTimer = null;
  function onChange(e) {
    var t = e.target;
    if (!t.name) return;
    if (t.type === 'number') {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { render(formUrl()); }, 600);
      return;
    }
    render(formUrl());
  }

  form.addEventListener('change', onChange);
  root.querySelector('[data-pc-sort]').addEventListener('change', onChange);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    render(formUrl());
  });

  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pc-link], [data-pc-clear]');
    if (link) {
      e.preventDefault();
      render(sectionUrl(link.href).toString());
      return;
    }

    var next = e.target.closest('[data-pc-next]');
    if (next) {
      e.preventDefault();
      loadMore(next);
      return;
    }

    if (e.target.closest('[data-pc-open]')) openSheet();
    else if (e.target.closest('[data-pc-close]') || e.target === scrim) closeSheet();
  });

  /* --- load more ------------------------------------------------------------ */

  // Append one fetched page's products and take over its "Load more" link.
  function appendPage(doc) {
    var grid = root.querySelector('[data-pc-grid]');
    var firstNew = null;
    doc.querySelectorAll('[data-pc-grid] > li').forEach(function (li, i) {
      var node = document.importNode(li, true);
      if (i === 0) firstNew = node;
      grid.appendChild(node);
    });
    var more = doc.querySelector('[data-pc-more]');
    var current = root.querySelector('[data-pc-more]');
    if (current) {
      if (more) current.replaceWith(more);
      else current.remove();
    }
    return firstNew;
  }

  function loadMore(link) {
    link.setAttribute('aria-busy', 'true');
    fetchSection(link.href).then(function (doc) {
      var firstNew = appendPage(doc);
      saveState({ lastPage: pageOf(link.href) });
      // Move keyboard focus to the first new product so the next Tab continues there.
      if (firstNew) {
        var a = firstNew.querySelector('a');
        if (a) a.focus({ preventScroll: true });
      }
    }).catch(function (err) {
      if (err.name !== 'AbortError') window.location.href = link.href;
    });
  }

  /* --- back to where you were --------------------------------------------------- */

  // "Load more" appends pages without changing the URL. When the browser keeps
  // this page in its back/forward cache, Back shows it exactly as it was; when
  // it does not (a few pages deeper, or a phone short of memory), the page
  // reloads with only its first page of products and the scroll clamps above
  // the product the shopper clicked. So the last page loaded and the scroll
  // position live in history.state, which belongs to this history entry and
  // survives that reload.

  function pageOf(url) {
    return Number(new URL(url, window.location.origin).searchParams.get('page')) || 1;
  }

  function saveState(extra) {
    history.replaceState(Object.assign({}, history.state, { pc: true }, extra), '');
  }

  var restoring = false;
  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (restoring) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () { saveState({ scrollY: window.scrollY }); }, 200);
  }, { passive: true });

  // The debounce can miss the last moment before a product click; record it now.
  root.addEventListener('click', function (e) {
    if (!restoring && e.target.closest('[data-pc-grid] a')) saveState({ scrollY: window.scrollY });
  }, true);

  function restore() {
    var saved = history.state;
    if (!saved || !saved.pc || !saved.lastPage) return;
    // A shopper can land on ?page=3 (a no-script link, a search result); restore from there.
    var from = pageOf(window.location.href);
    if (saved.lastPage <= from) return;

    restoring = true;
    history.scrollRestoration = 'manual';
    if (controller) controller.abort();
    controller = new AbortController();
    var signal = controller.signal;
    var pages = [];
    for (var p = from + 1; p <= saved.lastPage; p++) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', p);
      pages.push(fetchDoc(u.toString(), signal));
    }
    Promise.all(pages).then(function (docs) {
      docs.forEach(appendPage);
      if (saved.scrollY) window.scrollTo(0, saved.scrollY);
    }).catch(function () {
      // A filter change aborted it, or a page failed: the first page still stands.
    }).finally(function () {
      restoring = false;
      history.scrollRestoration = 'auto';
    });
  }

  restore();

  /* --- mobile sheet ----------------------------------------------------------- */

  function openSheet() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    scrim.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var close = form.querySelector('[data-pc-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    scrim.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    // Land on the results, not wherever the page was scrolled to.
    var bar = root.querySelector('[data-pc-bar]');
    if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'start' });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  // Rotating to a desktop width with the sheet open must not leave the page locked.
  window.matchMedia('(min-width: 861px)').addEventListener('change', function (mq) {
    if (mq.matches) closeSheet();
  });
})();
